import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

export function Row(props: Props) {
  return (
    <div
      className={twMerge(
        'bg-neutral-950',
        'border-neutral-900',
        'border',
        'gap-x-4',
        'grid',
        'items-center',
        'p-4',
        'rounded-lg',
        props.className,
      )}
    >
      {props.children}
    </div>
  );
}
